'use strict';

var JSONStorageStateSource = require('./jsonStorage');
var registerStateSource = require('../core/registerStateSource');

module.exports = function (marty) {
  registerStateSource(marty, 'JSONStorageStateSource', 'jsonStorage', JSONStorageStateSource);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/json-storage-state-source/index.js
 ** module id = 571
 ** module chunks = 0
 **/